import { render, staticRenderFns } from "./SearchableDocumentsListResources.vue?vue&type=template&id=ed0538d0"
import script from "./SearchableDocumentsListResources.vue?vue&type=script&lang=ts"
export * from "./SearchableDocumentsListResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed0538d0')) {
      api.createRecord('ed0538d0', component.options)
    } else {
      api.reload('ed0538d0', component.options)
    }
    module.hot.accept("./SearchableDocumentsListResources.vue?vue&type=template&id=ed0538d0", function () {
      api.rerender('ed0538d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/SearchableDocumentsListResources.vue"
export default component.exports